export var ModalTypes;
(function (ModalTypes) {
    ModalTypes["vertical"] = "vertical";
    ModalTypes["horizontal"] = "horizontal";
})(ModalTypes || (ModalTypes = {}));
export var ModalButtonTypes;
(function (ModalButtonTypes) {
    ModalButtonTypes["sided"] = "sided";
    ModalButtonTypes["pilled"] = "pilled";
})(ModalButtonTypes || (ModalButtonTypes = {}));
//# sourceMappingURL=constants.js.map